import { gql } from "@apollo/client";
import { MutationResponseWithId } from "../../sharedTypes";

export const DO_LOCATION_CALIBRATION = gql`
  mutation doLocationCalibration($domain: String!, $locationIds: [Int!]!, $triggerAmount: Int!, $pauseTime: Int!, $calibrationAmount: Int!) {
    location {
      doCalibration(domain: $domain, locationIds: $locationIds, triggerAmount: $triggerAmount, pauseTime: $pauseTime, calibrationAmount: $calibrationAmount) {
        code
        message
        success
        id
      }
    }
  }
`

export interface DoLocationCalibration {
  domain: string
  locationIds: number[]
  triggerAmount: number
  pauseTime: number
  calibrationAmount: number
}

export interface DoLocationCalibrationResponse {
  location: {
    doCalibration: MutationResponseWithId[]
  }
}

export const DO_CALIBRATION_MULTIPLE = gql`
  mutation DoCalibrationMultiple($domain: String!, $terminalIds: [Int!]!, $triggerAmount: Int!, $pauseTime: Int!, $calibrationAmount: Int!) {
    terminal {
      doCalibrationMultiple(domain: $domain, terminalIds: $terminalIds, triggerAmount: $triggerAmount, pauseTime: $pauseTime, calibrationAmount: $calibrationAmount) {
        code
        message
        success
        id
      }
    }
  }
`

export interface DoCalibrationMultiple {
  domain: string
  terminalIds: number[]
  triggerAmount: number
  pauseTime: number
  calibrationAmount: number
}

export interface DoCalibrationMultipleResponse {
  terminal: {
    doCalibrationMultiple: MutationResponseWithId[]
  }
}

export const UPDATE_CONFIG_FROM_CALIBRATION_LOCATION = gql`
  mutation UpdateConfigFromCalibration($domain: String!, $updateValues: [TerminalGramPerRotation!]!) {
    location {
      updateConfigFromCalibration(domain: $domain, updateValues: $updateValues) {
        code
        message
        success
        id
      }
    }
  }
`

export interface ConfigUpdateValue {
  id: number
  gramPerRotation: number
}

export interface UpdateConfigFromCalibrationLocation {
  domain: string,
  updateValues: ConfigUpdateValue[]
}

export interface UpdateConfigFromCalibrationLocationResponse {
  location: {
    updateConfigFromCalibration: MutationResponseWithId[]
  }
}

export const UPDATE_CONFIG_FROM_CALIBRATION_MULTIPLE = gql`
  mutation UpdateConfigFromCalibrationMultiple($domain: String!, $updateValues: [TerminalGramPerRotation!]!) {
    terminal {
      updateConfigFromCalibrationMultiple(domain: $domain, updateValues: $updateValues) {
        code
        message
        success
        id
      }
    }
  }
`

export interface UpdateConfigFromCalibrationMultipleResponse {
  terminal: {
    updateConfigFromCalibrationMultiple: MutationResponseWithId[]
  }
}

